
import { gql } from "@apollo/client";

export const Qualification = gql`
 query da_qualifications(
  $active: Boolean!
) {
  aatmsv4_qualifications(order_by: {clientname: asc, qcode: asc}, where: {active: {_eq: $active}}) {
    clientname
    qcode
    qualification
    category
    subcategory
    caption1
    caption2
    caption3
    validity
    active
    clientsid
    cost
    managersid1
    managersid2
    managersid3
    qid
    _aircraft
    _crew
    _ground
    _manager
    _optimiser
    _simulator
    manager {
      managername
      managersid
    }
    managerByManagersid2 {
      managername
    }
  }
}
`
export const Qualification_Query = gql`
query da_qualifications {
    aatmsv4_qualifications(where: {active: {_eq: true}}, order_by: {clientname: asc, qcode: asc}) {
      clientname
      qcode
      qualification
      category
      subcategory
      caption1
      caption2
      caption3
      validity
      active
      clientsid
      cost
      managersid1
      managersid2
      managersid3
      qid
      _aircraft
      _crew
      _ground
      _manager
      _optimiser
      _simulator
      manager {
        managername
        managersid
      }
      managerByManagersid2 {
        managername
      }
    }
  }
`
export const clients = gql`
query Da_Clients {
  aatmsv4_clients{
    clientsid
    clientname
  }
}
`
export const getClientId = gql`
query login(
    $id: String
) {
  aatmsv4_users(where: {userid: {_eq: $id}}) {
    client {
      clientname
      clientsid
    }
    email
  }
}
`
export const category = gql`
query MyQuery {
    aatmsv4_category {
      categoryid
    }
  }
`
export const subcatagory = gql`
query MyQuery {
    aatmsv4_subcategory {
      subcategoryid
    }
  }
  
`
export const Manager = gql`
query Da_qualification_Manager_clientwise($id: uuid) {
  aatmsv4_managers(order_by: {managername: asc}, where: {clientsid: {_eq: $id}}, limit: 10) {
    managername
    managersid
  }
}
`

export const Qualification_Add = gql`
  mutation da_qualifications_add(
      $Validy: Int!
      $Cost: Int!
      $managerId: String!
      $managerName: String
      $clientid: uuid!
      $clientname: String!
      $qCode: String!
      $QualificationName: String!
      $caption1: String!
      $caption2: String!
      $caption3: String!
      $manager2: String
      $manager3: String
  ) {
    insert_aatmsv4_qualifications(objects: {
      clientsid: $clientid, 
      clientname: $clientname, 
      qcode: $qCode, 
      qualification: $QualificationName, 
      category: Certificate, 
      subcategory: Mandatory, 
      validity: $Validy,  
      cost: $Cost, 
      caption1: $caption1, 
      caption2: $caption2, 
      caption3: $caption3, 
      active: true, 
      _aircraft: true, 
      _crew: true, 
      _ground: true, 
      _manager: true, 
      _optimiser: true, 
      _simulator: true, 
      managersid1: $managerId,
      managersid2: $manager2, 
      managersid3: $manager3
    }) {
      returning {
        clientsid
        clientname
        qid
        qcode
        qualification
        category
        subcategory
        validity
        cost
        caption1
        caption2
        caption3
        active
        _crew
        _ground
        _simulator
        _aircraft
        _manager
        _optimiser
      }
    }
  }
  `
  export const Qualification_Update = gql`
  mutation MyMutation(
      $active:Boolean!
      $cost: Int!
      $caption2: String!
      $caption3: String!
      $validity: Int!
      $caption1: String!
      $qcode: String!
      $qualification: String!
      $clientName: String!
      $clientid: uuid!
      $manager: String!
      $id: uuid!

  ) {
    update_aatmsv4_qualifications(where: {qid: {_eq: $id}}, _set: {validity: $validity,qualification: $qualification,_aircraft: true, _crew: true, _ground: true, _manager: true, _optimiser: true, _simulator: true, active: $active, caption1:$caption1 , caption2: $caption2, caption3: $caption3, category: Ground, clientname: $clientName, clientsid:$clientid , cost: $cost, managersid1: $manager, qcode: $qcode, subcategory: Mandatory}) {
      returning {
        _aircraft
        active
        caption1
        caption2
        caption3
        category
        clientname
        clientsid
        cost
        managersid1
        managersid2
        qcode
        managersid3
        qid
        qualification
        subcategory
      }
    }
  }
  `
export const qmap1 = gql`
mutation da_qualifications_add_step1(
  $id: uuid
  $clientsid: uuid
  $email: String
  $managersid1: String
  $qcode: String
) {
  insert_aatmsv4_qmap(objects: {active: true, addedby: $email, clientsid: $clientsid, managersid: $managersid1, qid: $id, qcode: $qcode}) {
    returning {
      qualification {
        qualification
      }
    }
  }
}
`
export const qmap2 = gql`
mutation da_qualifications_add_step2(
  $id: uuid
  $clientsid: uuid
  $email: String
  $managersid1: String
  $qcode: String
) {
  insert_aatmsv4_qmap(objects: {active: true, addedby: $email, clientsid: $clientsid, managersid: $managersid1, qid: $id, qcode: $qcode}) {
    returning {
      qualification {
        qualification
      }
    }
  }
}
`
export const qmap3 = gql`
mutation da_qualifications_add_step3($id: uuid,
   $clientsid: uuid,
   $qcode: String,
    $email: String,
     $managersid1: String) {
  insert_aatmsv4_qmap(objects: {active: true, addedby: $email, clientsid: $clientsid, managersid: $managersid1, qid: $id, qcode: $qcode}) {
    returning {
      qualification {
        qualification
      }
    }
  }
}
`